module.exports = __webpack_public_path__ + "img/topic.c698c142.svg";